//@ts-nocheck
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "../bootstrap/Button";
import { observer } from "mobx-react";
import auth from "../../shared/mobx/auth-state";
import subscriptionState from "../../shared/mobx/subscription-state";
import notificationState from "../../shared/mobx/notification-state";
import { Paddle } from "@paddle/paddle-js";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "../bootstrap/Modal";
import LoaderWrapper from "../../layout/Wrapper/LoaderWrapper";

import userState from "../../shared/mobx/user-state";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const formatNumberWithDecimal = (num: number) => {
  return (num / 100).toFixed(2);
};

interface IProps {
  priceId: string | number;
  packagePrice?: number | string;
  paddle: Paddle;
  selected_plan?: boolean;
  package_id?: string | number;
  pdfLimit?: number;
  pending?: boolean;
  isActive?: boolean;
  currentPackage?: string;
  updateIsActive?: (priceId: string | number) => void;
}

const PaddlePay = (props: IProps) => {
  const [state, setState] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState<string>("Select Plan");
  const {
    priceId,
    packagePrice,
    paddle,
    selected_plan,
    package_id,
    updateIsActive,
    pdfLimit,
    isActive,
    currentPackage
  } = props;
  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const pending = props.pending;

  const isFreePlan = Number(packagePrice) === 0;

  // Support URL-driven selection (guest selects a plan before login)
  const [querySelectedPlan, setQuerySelectedPlan] = useState(false);
  const [queryPackageId, setQueryPackageId] = useState<string | number | undefined>(undefined);

  useEffect(() => {
    // Set proper action text for free plan
    if (isFreePlan && currentAction === "Select Plan") {
      setCurrentAction("Activate Free");
    }
  }, [isFreePlan, currentAction]);



  // Determine the current action based on the active subscription and plan details
  useEffect(() => {
    const hasPkg = !!(currentPackage && typeof currentPackage === 'object' && Object.keys(currentPackage).length > 0);
  
    // Ensure both values have the same decimal format
    const formattedPackagePrice = (Number(packagePrice) / 100).toFixed(2);
    const formattedCurrentPackagePrice = hasPkg && currentPackage.package_price != null
      ? parseFloat(currentPackage.package_price).toFixed(2)
      : "0.00";
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const activePrice = formattedCurrentPackagePrice;
  
    let newAction = "Select Plan";
    if (hasPkg) {
      if (currentPackage.plan_id === priceId && pdfLimit === 0) {
        newAction = "Renew";
      } else if (currentPackage.plan_id === priceId && pdfLimit > 0) {
        newAction = "Active";
      } else if (+formattedCurrentPackagePrice <= +formattedPackagePrice) { 
        newAction = "Upgrade";
      } else {
        newAction = "Downgrade";
      }
    }
  
    setCurrentAction(newAction);
  }, [priceId, currentPackage, packagePrice, isActive, pdfLimit]);
  

  // Handle the button click based on the current action
  // const handleAction = async () => {
  //   setLoading(true);
  //   try {
  //     let response;

  //     switch (currentAction) {
  //       case "Upgrade":
  //       case "Downgrade":
  //       case "Renew":
  //         // Update the subscription plan
  //         response = await subscriptionState.update(priceId);
  //         if (response?.status) {
  //           setState(false);
  //           setCurrentAction("Active");
  //           updateIsActive?.(priceId); // Update the active plan ID
  //           // Immediately update the currentPackage state to reflect the change
  //           currentPackage.plan_id = priceId; // Update the current package ID
  //         }
  //         break;

  //       case "Select Plan":
  //         // Open the checkout for a new plan
  //         await defaultCheckout();
  //         break;

  //       default:
  //         console.error("Invalid action:", currentAction);
  //         break;
  //     }
  //   } catch (error) {
  //     console.error("Error during plan change:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleAction = async () => {
    setLoading(true);
    try {
      console.log('=== PLAN CHANGE DEBUG ===');
      console.log('Current action:', currentAction);
      console.log('Is free plan:', isFreePlan);
      console.log('Package price:', packagePrice);
      console.log('Price ID:', priceId);
      console.log('Has customer ID:', !!auth.currentUser.customer_id);
      console.log('Has payment method:', subscriptionState.hasPaymentMethod);
      console.log('Current package:', currentPackage);

      if (isFreePlan) {
        // Free plan - activate without checkout
        console.log('Activating free plan...');
        const response = await subscriptionState.activateFreePlan(priceId);
        if (response?.status) {
          setCurrentAction("Active");
          if (props.updateIsActive) {
            await props.updateIsActive(priceId);
          }
          
          setTimeout(async () => {
            await Promise.all([
              userState.getUserStats(),
              subscriptionState.getActiveSubscriptionPlan()
            ]);
          }, 3000);
        }
        setState(false);
        return;
      }

      // Paid plan logic
      const hasExistingSubscription = !!subscriptionState._userSubscription?.id;
      // Check customer_id in both auth and subscription state
      const hasCustomerId = !!(auth.currentUser?.customer_id || subscriptionState._userSubscription?.customer_id);
      const isGuestUser = !hasCustomerId; // Guest user has no customer_id in either location
      
      console.log('Has existing subscription:', hasExistingSubscription);
      console.log('Is guest user:', isGuestUser);
      console.log('Has customer ID (auth):', !!auth.currentUser?.customer_id);
      console.log('Has customer ID (subscription):', !!subscriptionState._userSubsscription?.customer_id);

      // Special flow for guest users upgrading from free to pro
      if (isGuestUser && currentAction === "Upgrade") {
        console.log('Guest user upgrading from free to pro - opening checkout...');
        await defaultCheckout();
        return;
      }

      if (!hasExistingSubscription) {
        // First time paid subscription - use checkout
        console.log('First time paid subscription - opening checkout...');
        await defaultCheckout();
        return;
      }

      // User has existing subscription - show confirmation modal for upgrade/downgrade
      if (currentAction === "Upgrade" || currentAction === "Downgrade") {
        console.log('User has existing subscription - showing confirmation modal...');
        setState(true); // Show confirmation modal (no checkout)
        return;
      }

      // For renewals, update directly without checkout
      if (currentAction === "Renew") {
        console.log('Renewing subscription without checkout...');
        const response = await subscriptionState.update(priceId);
        if (response?.status) {
          setCurrentAction("Active");
          if (props.updateIsActive) {
            await props.updateIsActive(priceId);
          }
          setTimeout(async () => {
            await Promise.all([
              userState.getUserStats(),
              subscriptionState.getActiveSubscriptionPlan()
            ]);
          }, 3000);
        }
        setState(false);
      }
    } catch (error) {
      console.error("Error during plan change:", error);
      notificationState.addToasterError('Failed to process plan change. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Handle confirmed plan change (when user has payment method)
  const handleConfirmedPlanChange = async () => {
    setLoading(true);
    try {
      console.log('Processing confirmed plan change...');
      
      const response = await subscriptionState.update(priceId);
      if (response?.status) {
        setCurrentAction("Active");
        if (props.updateIsActive) {
          await props.updateIsActive(priceId);
        }
        
        setTimeout(async () => {
          await Promise.all([
            userState.getUserStats(),
            subscriptionState.getActiveSubscriptionPlan()
          ]);
        }, 3000);
        
        notificationState.addToasterSuccess(`Plan ${currentAction.toLowerCase()}d successfully!`);
      } else {
        notificationState.addToasterError('Failed to update plan. Please try again.');
      }
    } catch (error) {
      console.error('Error updating plan:', error);
      notificationState.addToasterError('Failed to update plan. Please try again.');
    } finally {
      setLoading(false);
      setState(false);
    }
  };

  // Open the Paddle checkout for the selected plan
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const openCustomerPortal = () => {
    // This function is reserved for future use
  };

  const defaultCheckout = () => {
    if (!priceId) {
      console.error("Price ID is required.");
      return;
    }

    const checkoutConfig = {
      items: [{ priceId: priceId.toString(), quantity: 1 }],
      customData: {
        userId: auth.currentUser!.id,
        email: auth.currentUser!.email,
        action: currentAction, // Track what action triggered checkout
      },
      customer:
        auth.currentUser.customer_id &&
        auth.currentUser.address_id &&
        auth.currentUser.business_id
          ? {
              id: auth.currentUser.customer_id,
              address: { id: auth.currentUser.address_id },
              business: auth.currentUser.business_id
                ? { id: auth.currentUser.business_id }
                : undefined,
            }
          : {
              email: auth.currentUser!.email,
              name: auth.currentUser?.firstName,
            },
    };

    // If user has existing payment method, allow them to update it
    if (subscriptionState.hasPaymentMethod && currentAction !== "Select Plan") {
      checkoutConfig.customData.updatePaymentMethod = true;
    }

    paddle?.Checkout.open(checkoutConfig);
  };

  // Parse query params once to recover pre-login selection (kept minimal; backend stores selected_plan)
  useEffect(() => {
    try {
      const sp = new URLSearchParams(window.location.search);
      const qp = sp.get("package_id") || sp.get("plan_id") || sp.get("priceId");
      if (qp) {
        setQueryPackageId(qp);
        setQuerySelectedPlan(true);
      }
      try { localStorage.removeItem("selected_free_plan"); } catch {}
    } catch {}
  }, []);

  // Helper to clear URL selection to avoid repeated triggers
  const clearQuerySelection = () => {
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete("package_id");
      url.searchParams.delete("plan_id");
      url.searchParams.delete("priceId");
      url.searchParams.delete("selected_plan");
      url.searchParams.delete("selected");
      window.history.replaceState({}, "", url.toString());
    } catch {}
    setQuerySelectedPlan(false);
    setQueryPackageId(undefined);
  };

  // Auto-flow: honor backend-selected plan ONLY for brand-new accounts (no customer)
  // Otherwise, require explicit URL selection to avoid unintended re-activation after cancel
  useEffect(() => {
    const hasActivePlan = !!(currentPackage && Object.keys(currentPackage).length > 0);
    const hasCustomerId = !!(auth?.currentUser?.customer_id || subscriptionState._userSubscription?.customer_id);
    const isBrandNewAccount = !!(auth?.currentUser && !hasCustomerId);
    const backendSelected = !!selected_plan && isBrandNewAccount;
    const effectiveSelected = backendSelected || querySelectedPlan;
    const effectivePackageId = (backendSelected && package_id) || queryPackageId;
    const isAuthReady = !!(auth?.currentUser && auth.currentUser.id);
    // Removed cancellation session guard

    if (!effectiveSelected || !effectivePackageId || effectivePackageId === "0") return;
    // Match selected id ONLY to this card's priceId
    const matchesCard = String(effectivePackageId) === String(priceId);
    if (!matchesCard) return; // Only act for matching card
    if (hasActivePlan || isActive) return; // Never auto-open when already active
    // If user recently cancelled, do not auto-activate free plan unless there's explicit selection
    // No cancellation guard; activation only occurs when URL selection exists
    
    // Wait for auth before performing any action
    if (!isAuthReady) return;

    const run = async () => {
      try {
        if (isFreePlan) {
          // Allow free activation if explicitly selected via URL OR selected on backend for brand-new accounts
          if (!(backendSelected || querySelectedPlan)) return;
          // Explicit selection present (via URL/props) → auto-activate free plan post-login
          const resp = await subscriptionState.activateFreePlan(effectivePackageId);
          if (resp?.status) {
            setCurrentAction("Active");
            if (updateIsActive) await updateIsActive(effectivePackageId);
            setTimeout(async () => {
              await Promise.all([
                userState.getUserStats(),
                subscriptionState.getActiveSubscriptionPlan(),
              ]);
            }, 1500);
            // Clear URL after success
            clearQuerySelection();
            // Clear backend stored selected_plan locally to avoid reactivation on refresh
            try { auth.clearPackageId(); } catch {}
          }
        } else {
          // Paid plans: open checkout
          if (!paddle) return; // Wait until paddle is ready to open checkout
          
          // Special handling for guest users upgrading from free to pro
          const hasCustomerIdAutoFlow = !!(auth.currentUser?.customer_id || subscriptionState._userSubscription?.customer_id);
          const isGuestUserAutoFlow = !hasCustomerIdAutoFlow;
          if (isGuestUserAutoFlow && currentAction === "Upgrade") {
            console.log('Guest user auto-flow: upgrading from free to pro - opening checkout...');
          }
          
          defaultCheckout();
          clearQuerySelection();
        }
      } catch (e) {
        // noop
      }
    };

    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFreePlan, auth.currentUser, querySelectedPlan, queryPackageId, paddle]);

  return (
    <>
      <Modal
        isOpen={state}
        setIsOpen={setState}
        titleId="confirmationModal"
        isStaticBackdrop={true}
        isCentered={true}
        isAnimation={true}
      >
        <ModalHeader setIsOpen={setState}>
          <ModalTitle id="exampleModalLabel">Confirmation</ModalTitle>
        </ModalHeader>
        <LoaderWrapper isLoading={loading} data={[true]}>
          <ModalBody>
            Are you sure you want to {currentAction.toLowerCase()} the plan?
          </ModalBody>
          <ModalFooter>
            <Button
              color="info"
              isOutline
              className="border-0"
              onClick={() => setState(false)}
              disabled={loading}
            >
              No
            </Button>
            <Button onClick={handleConfirmedPlanChange} color="info" disabled={loading}>
              {loading ? "Processing..." : "Yes"}
            </Button>
          </ModalFooter>
        </LoaderWrapper>
      </Modal>

      <Button
        onClick={() => {
          // Always call handleAction() - it will handle the logic internally
          handleAction();
        }}
        disabled={!paddle || currentAction === "Active"}
        isLight
        className="text-uppercase w-100"
        size="lg"
        color="primary"
        style={{
          borderRadius: "0",
          // marginBottom: "-4rem",
          marginLeft: "-0rem",
        }}
      >
        {currentAction}
      </Button>
    </>
  );
};

PaddlePay.propTypes = {
  priceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  packagePrice: PropTypes.number,
  pdfLimit: PropTypes.number,
  selected_plan: PropTypes.bool,
  package_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isActive: PropTypes.bool,
  updateIsActive: PropTypes.func,
};

export default observer(PaddlePay);